module.exports = __webpack_public_path__ + "static/media/catering-2.a04eb4cf.jpg";